import { useEffect, useContext } from 'react';
import { Context } from 'context';
import { UPDATE_COUNTRY_CONFIG } from 'context/actions';
import { getCountryConfig } from 'Shared/Utils';
import { USER_SERVICES } from 'Services';


export const useInitializeCountryConfig = (options = {}) => {
  const { 
    checkSingleCountry = true, 
    autoInitialize = true 
  } = options;
  
  const { dispatch } = useContext(Context);

  const initializeCountryConfig = async () => {
    try {
      const response = await USER_SERVICES.getSupportedCountries();
      
      if (response?.type === 'success' && response?.data) {
        const countryCodes = response?.data?.country_codes || [];
        
        const shouldUpdate = !checkSingleCountry || countryCodes.length === 1;
        
        if (shouldUpdate && countryCodes.length > 0) {
          dispatch({
            type: UPDATE_COUNTRY_CONFIG,
            payload: {
              countryConfig: getCountryConfig(countryCodes[0]),
            },
          });
        }
      }
    } catch (error) {
      console.error('Error initializing country config:', error);
    }
  };

  useEffect(() => {
    if (autoInitialize) {
      initializeCountryConfig();
    }
  }, []);

  return {
    initializeCountryConfig,
  };
};

